// @flow

import React from 'react';
import Select from 'react-select';

type Props = {
    placeholder: string,
    options: Object,
    onChange: Function,
    value: string,
    disabled?: boolean,
};

const ListFilter = (props: Props) => (
  <Select
    placeholder={props.placeholder}
    options={props.options}
    onChange={props.onChange}
    value={props.value}
    disabled={props.disabled}
  />
);


export default ListFilter;



// WEBPACK FOOTER //
// ./src/js/Components/ListFilter.js